export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-foreground-950">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-white mb-10 text-center">
          手机端吃瓜入口
        </h2>
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-14">
          <div className="shrink-0">
            <div className="w-56 md:w-64 aspect-[9/16] rounded-3xl overflow-hidden border-4 border-white/10 bg-foreground-800">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20a%20modern%20dark%20theme%20entertainment%20news%20app%20interface%20with%20pink%20accent%20headlines%2C%20scandal%20news%20feed%20layout%2C%20clean%20UI%20design%2C%20dark%20background%20with%20vibrant%20pink%20highlights%2C%20editorial%20news%20app%20aesthetic%2C%20minimal%20typography&width=512&height=910&seq=app-mockup&orientation=portrait"
                alt="51每日大赛手机端界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
              随时随地掌握最新反差视频
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6 max-w-md">
              深夜躺床吃瓜、通勤路上追踪内幕、排队间隙刷刷翻车现场——51每日大赛移动端为你提供最流畅的吃瓜体验。推送秒达，绝不错过任何一个大瓜。
            </p>
            <button className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer" type="button">
              <i className="ri-download-2-line"></i>
              打开APP体验
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}